import React, { useCallback, useRef, useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';

export const FilterModalContext = React.createContext<{
    showFilter: boolean;
    openFilter: () => void;
    closeFilter: () => void;
    openerRef: React.RefObject<HTMLElement | null>;
}>({
    showFilter: false,
    openFilter: () => {
        // eslint-disable-next-line no-console
        console.log(
            'openFilter not defined, did you wrap your components like this: <FilterModalProvider>...</FilterModalProvider>',
        );
    },
    closeFilter: () => {
        // eslint-disable-next-line no-console
        console.log(
            'closeFilter not defined, did you wrap your components like this: <FilterModalProvider>...</FilterModalProvider>',
        );
    },
    openerRef: { current: null },
});

export const FilterModalProvider: React.FC<React.PropsWithChildren> = React.memo((props) => {
    const [showFilter, setShowFilter] = useState(false);
    const openerRef = useRef<HTMLElement | null>(null);
    const openFilter = useCallback(() => setShowFilter(true), []);
    const closeFilter = useCallback(() => setShowFilter(false), []);
    return (
        <FilterModalContext.Provider value={{ showFilter, openFilter, closeFilter, openerRef }}>
            <Dialog.Root open={showFilter} onOpenChange={(open) => (open ? openFilter() : closeFilter())}>
                {props.children}
            </Dialog.Root>
        </FilterModalContext.Provider>
    );
});

export const FilterModalTrigger: React.FC<{ children: React.ReactElement }> = ({ children }) => {
    const { openerRef } = React.useContext(FilterModalContext);

    return (
        <Dialog.Trigger asChild onClick={(event) => (openerRef.current = event.currentTarget)}>
            {children}
        </Dialog.Trigger>
    );
};
